// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-sub-header {
  width: 100%;
  min-height: 7.5rem;
  background-color: var(--primary-color);
  padding: var(--xxl-content-padding);
}
.gyramais-sub-header .content {
  margin: auto;
  max-width: 1598px;
}
.gyramais-sub-header .title-container {
  width: 70%;
}
@media (max-width: 992px) {
  .gyramais-sub-header .title-container {
    width: 100%;
  }
}
.gyramais-sub-header .subtitle-container {
  width: 70%;
}
.gyramais-sub-header .subtitle-container p {
  font-size: 1.25rem;
  white-space: pre-wrap;
}
@media (max-width: 768px) {
  .gyramais-sub-header .subtitle-container p {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .gyramais-sub-header .subtitle-container {
    width: 100%;
  }
}
.gyramais-sub-header .left-side .gyramais-btn + .gyramais-btn {
  margin-top: 1rem;
}
@media (max-width: 768px) {
  .gyramais-sub-header .left-side .gyramais-btn {
    margin-bottom: 1rem;
  }
}
.gyramais-sub-header .right-side {
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .gyramais-sub-header .right-side .extra-container {
    margin: 1rem 0;
  }
}
.gyramais-sub-header .right-side .gyramais-btn + .gyramais-btn {
  margin-left: 1rem;
}
@media (max-width: 768px) {
  .gyramais-sub-header .right-side {
    justify-content: flex-start;
    display: block;
  }
  .gyramais-sub-header .right-side .gyramais-btn + .gyramais-btn {
    margin: 1rem 0;
  }
}
@media (max-width: 1200px) {
  .gyramais-sub-header {
    padding: var(--xl-content-padding);
  }
}
@media (max-width: 768px) {
  .gyramais-sub-header {
    padding: var(--md-content-padding);
  }
  .gyramais-sub-header .gyramais-btn {
    width: 100%;
  }
}
.gyramais-sub-header .sub-header-skeleton {
  opacity: 0.5;
}
.gyramais-sub-header .sub-header-skeleton .ant-skeleton-title {
  border-radius: 0.2rem;
  height: 3rem !important;
}
.gyramais-sub-header .sub-header-skeleton .ant-skeleton-paragraph li {
  border-radius: 0.2rem;
}
.gyramais-sub-header .sub-header-skeleton .ant-skeleton-paragraph li + li {
  margin-top: 0.3rem;
}
.gyramais-sub-header .sub-header-button-skeleton {
  opacity: 0.75;
  border-radius: 0.2rem;
  height: 3rem !important;
  width: 10rem;
  margin: 0.2rem 0;
}
.gyramais-sub-header .loan-chances-container {
  display: absolute;
  bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/gyramais/SubHeader/styles.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,sCAAA;EACA,mCAAA;AACF;AALA;EAOI,YAAA;EACA,iBAAA;AACJ;AATA;EAYI,UAAA;AAAJ;AAEI;EAAA;IACE,WAAA;EACJ;AACF;AAjBA;EAoBI,UAAA;AAAJ;AApBA;EAuBM,kBAAA;EACA,qBAAA;AAAN;AACM;EAAA;IACE,eAAA;EAEN;AACF;AACI;EAAA;IACE,WAAA;EAEJ;AACF;AAlCA;EAqCM,gBAAA;AAAN;AAGI;EAAA;IAEI,mBAAA;EADN;AACF;AA1CA;EAgDI,aAAA;EACA,yBAAA;AAHJ;AAKI;EAAA;IAEI,cAAA;EAHN;AACF;AAnDA;EA0DM,iBAAA;AAJN;AAOI;EAAA;IACE,2BAAA;IACA,cAAA;EAJJ;EAEE;IAKI,cAAA;EAJN;AACF;AAQE;EAAA;IACE,kCAAA;EALF;AACF;AAOE;EAAA;IACE,kCAAA;EAJF;EAGA;IAII,WAAA;EAJJ;AACF;AA5EA;EAoFI,YAAA;AALJ;AA/EA;EAuFM,qBAAA;EACA,uBAAA;AALN;AAnFA;EA6FQ,qBAAA;AAPR;AAtFA;EAiGQ,kBAAA;AARR;AAzFA;EAsGI,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAVJ;AAhGA;EA8GI,iBAAA;EACA,SAAA;AAXJ","sourcesContent":[".gyramais-sub-header {\n  width: 100%;\n  min-height: 7.5rem;\n  background-color: var(--primary-color);\n  padding: var(--xxl-content-padding);\n\n  .content {\n    margin: auto;\n    max-width: @content-max-width;\n  }\n\n  .title-container {\n    width: 70%;\n\n    @media (max-width: @lg-screen) {\n      width: 100%;\n    }\n  }\n\n  .subtitle-container {\n    width: 70%;\n\n    p {\n      font-size: 1.25rem;\n      white-space: pre-wrap;\n      @media (max-width: @md-screen) {\n        font-size: 1rem;\n      }\n    }\n\n    @media (max-width: @lg-screen) {\n      width: 100%;\n    }\n  }\n\n  .left-side {\n    .gyramais-btn + .gyramais-btn {\n      margin-top: 1rem;\n    }\n\n    @media (max-width: @md-screen) {\n      .gyramais-btn {\n        margin-bottom: 1rem;\n      }\n    }\n  }\n\n  .right-side {\n    display: flex;\n    justify-content: flex-end;\n\n    @media (max-width: @md-screen) {\n      .extra-container {\n        margin: 1rem 0;\n      }\n    }\n\n    .gyramais-btn + .gyramais-btn {\n      margin-left: 1rem;\n    }\n\n    @media (max-width: @md-screen) {\n      justify-content: flex-start;\n      display: block;\n\n      .gyramais-btn + .gyramais-btn {\n        margin: 1rem 0;\n      }\n    }\n  }\n\n  @media (max-width: @xl-screen) {\n    padding: var(--xl-content-padding);\n  }\n\n  @media (max-width: @md-screen) {\n    padding: var(--md-content-padding);\n\n    .gyramais-btn {\n      width: 100%;\n    }\n  }\n\n  .sub-header-skeleton {\n    opacity: 0.5;\n\n    .ant-skeleton-title {\n      border-radius: 0.2rem;\n      height: 3rem !important;\n    }\n\n    .ant-skeleton-paragraph {\n      li {\n        border-radius: 0.2rem;\n      }\n\n      li + li {\n        margin-top: 0.3rem;\n      }\n    }\n  }\n  .sub-header-button-skeleton {\n    opacity: 0.75;\n    border-radius: 0.2rem;\n    height: 3rem !important;\n    width: 10rem;\n    margin: 0.2rem 0;\n  }\n\n  .loan-chances-container {\n    display: absolute;\n    bottom: 0;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
